import target from './target';
import subitem from './subitem';
import standard from './standard';
import evalScore from './evalscore';
import result from './result';
import total from './resulttotal';
import subresult from './subresult';
import audit from './audit';
import assign from './assign';
import myenter from './myenter';

export default {
    target,
    subitem,
    standard,
    evalScore,
    result,
    total,
    subresult,
    audit,
    assign,
    myenter
}